import { makeStyles } from "@material-ui/core/styles";
import React, { useCallback, useEffect, useState } from "react";

/*BootstrapTable anbd table Related*/

/*Loader */
import FadeIn from "react-fade-in";
/*animation*/
import Loader from "../../common/loader/Loader";
/*Inputs*/
/*Styles*/
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { FormLabel } from "react-bootstrap";
import { useUserRights } from "../../../contexts/UserRightsContext";
import "./PlayerMarketing.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  label: {
    fontSize: 12,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function PlayerMarketing(props) {
  const classes = useStyles();
  const [period, setPeriod] = React.useState(["0"]);
  const [idLineType, setIdLineType] = React.useState(0);
  const [idAgent, setIdAgent] = React.useState(0);
  const [idBook, setIdBook] = useState(0);
  const [idOffice, setIdOffice] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);

  /*Loader*/
  /**/

  const handleUpdate = (event, key, value) => {
    props.Player[key] = event ? event.target.value : value;
  };

  const [localPlayer, setLocalPlayer] = useState(props.Player);
  const handleChange = (event, key, value) => {
    setLocalPlayer({
      ...localPlayer,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setLocalPlayer(props.Player);
  }, [props.Player]);

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  const BULK_FIELDS = ["ScheduleFB", "ScheduleBB", "ScheduleBS","ScheduleHK"];
    
      const [indet, setIndet] = React.useState({});
    
      useEffect(() => {
        if (props.isBulk) {
          const init = {};
          BULK_FIELDS.forEach(f => { init[f] = true; }); 
          setIndet(init);
        } else {
          setIndet({}); 
        }
      }, [props.isBulk]);
    
      const handleCheck = (field) => {
        if (indet?.[field]) {
          setIndet(prev => ({ ...prev, [field]: false }));
        }
      };
    
      const isIndeterminate = (field) => !!(props.isBulk && indet?.[field]);

  if (!localPlayer) return <></>;
  return (
    <React.Fragment>
      <div className="flex flex-col gap-4">
        {isLoading ? (
          <FadeIn>
            <div className="d-flex justify-content-center align-items-center">
              <Loader height={360} width={360} />
            </div>
          </FadeIn>
        ) : undefined}
        <div className="vertical-options" hidden={!hasRights(40)}>
          <h3>Personal Info</h3>
          <TextField
            size="small"
            type="text"
            label="Address"
            value={localPlayer.address1}
            onChange={(event) => handleChange(event, "address1")}
            onBlur={(event) => handleUpdate(event, "address1")}
            variant="outlined"
          />
          <TextField
            size="small"
            type="text"
            value={localPlayer.address2}
            onChange={(event) => handleChange(event, "address2")}
            onBlur={(event) => handleUpdate(event, "address2")}
            variant="outlined"
          />

          <div className="flex flex-row gap-4">
            <TextField
              size="small"
              type="text"
              label="City"
              value={localPlayer.city}
              onChange={(event) => handleChange(event, "city")}
              onBlur={(event) => handleUpdate(event, "city")}
              variant="outlined"
            />
            <TextField
              size="small"
              type="text"
              label="State"
              value={localPlayer.state}
              onChange={(event) => handleChange(event, "state")}
              onBlur={(event) => handleUpdate(event, "state")}
              variant="outlined"
            />
            <TextField
              size="small"
              type="text"
              label="Zip"
              value={localPlayer.zip}
              onChange={(event) => handleChange(event, "zip")}
              onBlur={(event) => handleUpdate(event, "zip")}
              variant="outlined"
            />
          </div>

          <div className="flex flex-row gap-4">
            <TextField
              size="small"
              type="text"
              label="Country"
              value={localPlayer.country}
              onChange={(event) => handleChange(event, "country")}
              onBlur={(event) => handleUpdate(event, "country")}
              variant="outlined"
            />
            <TextField
              size="small"
              type="text"
              label="Phone"
              value={localPlayer.phone}
              onChange={(event) => handleChange(event, "phone")}
              onBlur={(event) => handleUpdate(event, "phone")}
              variant="outlined"
            />
            <TextField
              size="small"
              type="text"
              label="Fax"
              value={localPlayer.fax}
              onChange={(event) => handleChange(event, "fax")}
              onBlur={(event) => handleUpdate(event, "fax")}
              variant="outlined"
            />
          </div>
          <div className="flex flex-row gap-4">
            <TextField
              size="small"
              type="text"
              label="E-mail"
              value={localPlayer.email}
              onChange={(event) => handleChange(event, "email")}
              onBlur={(event) => handleUpdate(event, "email")}
              variant="outlined"
            />
            <TextField
              size="small"
              type="datetime-local"
              label="Date Of Birth"
              value={localPlayer.dateOfBirth}
              onChange={(event) => handleChange(event, "dateOfBirth")}
              onBlur={(event) => handleUpdate(event, "dateOfBirth")}
              variant="outlined"
            />
          </div>
          <div className="flex flex-row gap-4">
            {/* SHOULD BE IdSource */}
            <TextField
              size="small"
              type="text"
              label="Source"
              value={localPlayer.idSource}
              onChange={(event) => handleChange(event, "idSource")}
              // onBlur={(event) => handleUpdate(event, "IdSource")}
              disabled
              variant="outlined"
            />
            <TextField
              size="small"
              type="text"
              label="Sign Up IP"
              value={localPlayer.signUpIP}
              onChange={(event) => handleChange(event, "signUpIP")}
              onBlur={(event) => handleUpdate(event, "signUpIP")}
              variant="outlined"
            />
          </div>
        </div>

        <div className="vertical-options">
          <h3>Free Plays</h3>
          <TextField
            size="small"
            type="text"
            label="Flag Message"
            value={localPlayer.freePlayMessage}
            onChange={(event) => handleChange(event, "freePlayMessage")}
            // onBlur={(event) => handleUpdate(event, "FreePlayMessage")}
            disabled
            variant="outlined"
          />
        </div>

        <div className="flex flex-row gap-4">
          <div className="vertical-options">
            <h3>Schedule</h3>
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localPlayer.scheduleFB}
                  indeterminate={isIndeterminate("scheduleFB")}
                  onChange={(event) => {
                    handleChange(undefined, "scheduleFB", event.target.checked);
                    handleUpdate(undefined, "scheduleFB", event.target.checked);
                    handleCheck("scheduleFB")
                  }}
                  color="primary"
                />
              }
              label="Football"
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localPlayer.scheduleBB}
                  indeterminate={isIndeterminate("scheduleBB")}
                  onChange={(event) => {
                    handleChange(undefined, "scheduleBB", event.target.checked);
                    handleUpdate(undefined, "scheduleBB", event.target.checked);
                    handleCheck("scheduleBB")
                  }}
                  color="primary"
                />
              }
              label="Basketball"
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localPlayer.scheduleBS}
                  indeterminate={isIndeterminate("scheduleBS")}
                  onChange={(event) => {
                    handleChange(undefined, "scheduleBS", event.target.checked);
                    handleUpdate(undefined, "scheduleBS", event.target.checked);
                    handleCheck("scheduleBS")
                  }}
                  color="primary"
                />
              }
              label="Baseball"
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localPlayer.scheduleHK}
                  indeterminate={isIndeterminate("scheduleHK")}
                  onChange={(event) => {
                    handleChange(undefined, "scheduleHK", event.target.checked);
                    handleUpdate(undefined, "scheduleHK", event.target.checked);
                    handleCheck("scheduleHK")
                  }}
                  color="primary"
                />
              }
              label="Hockey"
            />
          </div>
          <div className="flex-1 vertical-options">
            <h3>Bonus Points</h3>

            <div className="flex flex-row gap-4">
              <TextField
                className="flex-1"
                size="small"
                type="datetime-local"
                label="Bonus Start On"
                value={localPlayer.bonusPointsStart}
                onChange={(event) => handleChange(event, "bonusPointsStart")}
                onBlur={(event) => handleUpdate(event, "bonusPointsStart")}
                variant="outlined"
              />
              <Button
                className="!w-36"
                variant="contained"
                disabled
                //startIcon={<SearchIcon />}
              >
                Bonus Points
              </Button>
            </div>
            <div className="flex flex-row gap-4">
              <TextField
                className="flex-1"
                size="small"
                type="datetime-local"
                label="Bonus Expires"
                value={localPlayer.bonusPointsExpire}
                onChange={(event) => handleChange(event, "bonusPointsExpire")}
                onBlur={(event) => handleUpdate(event, "bonusPointsExpire")}
                variant="outlined"
              />
              <Button
                className="!w-36"
                variant="contained"
                disabled
                //startIcon={<SearchIcon />}
              >
                Recalculate
              </Button>
            </div>
            <FormControl component="fieldset">
              <FormLabel component="legend">Status</FormLabel>
              <RadioGroup
                label
                value={localPlayer.bonusPointsStatus}
                onChange={(event) => {
                  handleChange(event, "bonusPointsStatus");
                  handleUpdate(event, "bonusPointsStatus");
                }}
                row
              >
                <FormControlLabel
                  control={<Radio value="E" size="small" color="primary" />}
                  label="Enabled"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value="D" size="small" color="primary" />}
                  label="Disabled"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value="B" size="small" color="primary" />}
                  label="Banned"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
